import { Vue, Component } from 'vue-property-decorator';
import '@/registerVuePlugins';

import { default as MyTasksPage } from './Components/MyTasksPage.vue';

@Component({
  name: 'my-tasks-component',
  components: { MyTasksPage }
})
class MyTasksComponent extends Vue {
  public verificationToken: string = '';

  public async mounted() {
    this.verificationToken = await this.$verificationToken();
  }
}

new MyTasksComponent()
  .$mount('#my-tasks-view');